import React, { useState } from "react";
import { Box, Tabs, Tab, useTheme, alpha, useMediaQuery } from "@mui/material";
import Header from "components/Header";
import GroupLoanApplicationsTable from "./GroupLoanApplicationsTable";
import RepaidLoansTable from "./RepaidLoansTable";
import LoanProductsTable from "./LoanProductsTable"; // ✅ new

const AllLoans = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ m: { xs: "0.75rem", sm: "1rem 1.5rem", md: "1.5rem 2.5rem" }, minWidth: 0 }}>
      <Header title="ALL LOANS" subtitle="All Loan Activities in Your Group" />

      <Box sx={{ borderBottom: 1, borderColor: alpha(theme.palette.secondary[200], 0.2), mb: 2 }}>
        <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} variant={isMobile ? "scrollable" : "standard"} scrollButtons="auto" allowScrollButtonsMobile sx={{ minHeight: 44 }}>
          <Tab label="Loan Applications" />
          <Tab label="Repaid Loans" />
          <Tab label="Loan Products" /> {/* ✅ new */}
        </Tabs>
      </Box>

      {tab === 0 && <GroupLoanApplicationsTable />}
      {tab === 1 && <RepaidLoansTable />}
      {tab === 2 && <LoanProductsTable />} {/* ✅ new */}
    </Box>
  );
};

export default AllLoans;
